/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:31:54
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:12:09
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import base from './base/index'
import research from './research/index'
import testee from './testee/index'
import center from './center/index'
import recruit from './recruit/index'
Vue.use(Vuex)
export default new Vuex.Store({
	modules: { center, testee, research, recruit, base }
})